import { Navigate, Route, Routes } from 'react-router-dom'
import './App.css'
import { useAuth } from './auth/AuthContext'
import { Layout } from './Layout'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ChildLedgerPage } from './pages/ChildLedgerPage'
import { RatesAdminPage } from './pages/RatesAdminPage'
import { AllowanceAdminPage } from './pages/AllowanceAdminPage'

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth()
  if (status === 'checking') return <p className="loading">Loading…</p>
  if (status === 'unauthenticated') return <Navigate to="/login" replace />
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <Layout>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/children/:id" element={<ChildLedgerPage />} />
                <Route path="/rates" element={<RatesAdminPage />} />
                <Route path="/allowance" element={<AllowanceAdminPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </RequireAuth>
        }
      />
    </Routes>
  )
}
